import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ContainerScrollModule } from '@app/components/container-scroll/container-scroll.module';
import { HeaderModule } from '@app/components/header/header.module';
import { ListItemsModule } from '@app/components/list-items/list-items.module';
import { TabScrollSpyModule } from '@app/components/tab-scroll-spy/tab-scroll-spy.module';
import { LazyModule } from '@app/shared';
import { SharedModule } from '@app/shared/shared.module';
import {PublishersComponent} from "@app/app/publishers/publishers.component";
import {PublishersRoutingModule} from "@app/app/publishers/publishers-routing.module";


@NgModule({
  declarations: [
    PublishersComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    HeaderModule,
    PublishersRoutingModule,
    ContainerScrollModule,
    TabScrollSpyModule,
    LazyModule,
    ListItemsModule
  ]
})
export class PublishersModule { }
